import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError, apiErrorCode, takeAuthNotice } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { AuthShell, ErrorBox, Field, NoticeBox, inputCls, primaryBtn } from "@/components/auth/AuthUi";

const LOGIN_MESSAGES = {
  ACCOUNT_LOCKED: "Too many failed sign-in attempts. Wait a while and try again, or ask an administrator.",
  ACCOUNT_DISABLED: "This account has been disabled. Contact an administrator.",
  RATE_LIMITED: "Too many sign-in attempts from this device. Try again later.",
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [notice] = useState(() => takeAuthNotice());
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/broker");                // a required password change is handled by the protected shell
    } catch (e2) {
      setErr(LOGIN_MESSAGES[apiErrorCode(e2)] || apiError(e2));
      setPassword("");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign in" subtitle="GroundZero team access · accounts are created by an administrator" testId="login-form">
      <form onSubmit={submit} className="space-y-4">
        <NoticeBox testId="login-notice">{notice}</NoticeBox>
        <Field label="Email">
          <input data-testid="login-email" type="email" autoComplete="username" value={email} autoFocus
            onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
        </Field>
        <Field label="Password">
          <input data-testid="login-password" type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
        </Field>
        <ErrorBox testId="login-error">{err}</ErrorBox>
        <button type="submit" disabled={loading} data-testid="login-submit" className={`w-full ${primaryBtn}`}>
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
        </button>
        <div className="text-[10px] text-slate-600 text-center">
          Forgot your password? Ask an administrator for a reset link. No investment advice. PAPER mode.
        </div>
      </form>
    </AuthShell>
  );
}
